var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"2"}},[_c('v-card-title',[_vm._v(_vm._s(_vm.reporte.titulo))]),(_vm.reporte.layout)?_c('v-card-text',[_c('GenerarComponentes',{attrs:{"layout":_vm.reporte.layout}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }